var DesktopBetCompanies = function() {
    return {
        init: function() {
            $('[data-toggle=tooltip]').tooltip();
        }
    };
}();
